import React, { useState, useRef, useMemo } from 'react';
import JoditEditor from 'jodit-react';

export const SergTestPage = () => {
  const [content, setContent] = useState('');

  const handleBodyContentChange = (e: string) => {
    setContent(e);
  };

  return (
    <section style={{ paddingTop: '200px' }}>
      <div className="_container">
        <JoditEditor
          value={content}
          config={{
            readonly: false,
            buttons: [
              'undo',
              'redo',
              '|',
              'bold',
              'italic',
              'underline',
              'strikeThrough',
              '|',
              'ul',
              'ol',
              '|',
              'font',
              'fontsize',
              'brush',
              'paragraph',
              '|',
              'link',
              '|',
              'left',
              'center',
              'right',
              'justify',
            ],
            extraButtons: ['|', 'source'],
          }}
          tabIndex={1}
          onChange={handleBodyContentChange}
        />
      </div>
    </section>
  );
};
